import { AppBar as AlchemyAppBar } from '@m/alchemy-ui/AppBar';
import { AppMenuButtonMobile } from '@m/alchemy-ui/AppMenuButtonMobile';
import { AppMenuList as AlchemyAppMenuList } from '@m/alchemy-ui/AppMenuList';
import { ListIcon } from '@m/alchemy-ui/icons/ListIcon';
import styled from 'styled-components';

const AppBar = styled(AlchemyAppBar)`
    background: transparent;
    padding: 0;
    span {
        display: flex;
    }
`;

const AppMenuList = styled(AlchemyAppMenuList)`
  padding-left: 0;
`;

export const MobileMenu = ({ children }) => {
  return (
    <AppBar>
      <AppMenuButtonMobile
        attachedMobileMenuTo="left"
        label={<ListIcon aria-label="Open menu" />}
        overlay={() => <AppMenuList>{children}</AppMenuList>}
      />
    </AppBar>
  );
};
